import React from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="gallery-title" data-id="element-44" data-mp="34cggj9htgcin">
      <div className="mx-auto max-w-6xl px-5 text-center" data-id="element-45" data-mp="34esxbjbu8gu4">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-46" data-mp="3iawqd9az6j50">
          Inspiración sin límites
        </span>
        <h2 id="gallery-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-47" data-mp="3dbbq8vk2k4qp">
          Mirá lo que vas a poder crear
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-muted" data-id="element-48" data-mp="2kmmk2i45p983">
          Con el Método Maestro vas a tener las bases para tejer cualquiera de estos diseños y
          muchos más.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6
      }} className="mt-12 overflow-hidden rounded-[2rem] shadow-soft" data-id="element-49" data-mp="2ukkbfehbbm4x">
          <img src="https://cdn.magicpatterns.com/uploads/mT9SJ8A6Timis39e7QVDdL/ChatGPT_Image_11_ago_2026,_11_17_25_a.m..png" alt="50 ideas de patrones amigurumis" className="h-full w-full object-cover" data-id="element-50" data-mp="rc1guiwhsi9x" />
        </motion.div>
      </div>
    </section>;
}